module.exports = __webpack_public_path__ + "img/cover-2.a815362d.png";